import { useMemo } from "react";
import { LandingShell } from "@/components/design-switcher";
import {
  readerIdOf,
  type SessionStore,
  sessionStore,
  useSession,
} from "@/convex/session";
import { landingBooks } from "@/library/books";
import { useBookmarks } from "@/library/use-bookmarks";
import { isUnconfirmed } from "@/storage/unconfirmed-reader";

// A scanned reader nobody has confirmed yet must not see "next in series"
// built from its progress: the landing shows the series' first books.
export function HomePage({ store = sessionStore }: { store?: SessionStore }) {
  const readerId = readerIdOf(useSession(store));
  const bookmarks = useBookmarks();
  const confirmed = readerId === null || !isUnconfirmed(readerId);
  const props = useMemo(
    () => landingBooks(confirmed ? bookmarks : []),
    [bookmarks, confirmed],
  );
  return <LandingShell {...props} />;
}
